import React from 'react';
import { Menu } from 'antd';
import {
	AppstoreOutlined,
	BankOutlined,
	CommentOutlined,
	KeyOutlined,
	MailOutlined,
	StarOutlined,
	UnorderedListOutlined,
	UserOutlined,
} from '@ant-design/icons';
import { NavLink, useLocation } from 'react-router-dom';
import * as S from './Navbar.styled';

export const menuItems = [
	{
		key: '/',
		icon: <MailOutlined />,
		label: <NavLink to="/">Requests (guests)</NavLink>,
	},
	{
		key: '/consultations',
		icon: <CommentOutlined />,
		label: <NavLink to="/consultations">Consultations (users)</NavLink>,
	},
	{
		key: '/saved',
		icon: <StarOutlined />,
		label: <NavLink to="/saved">Saved</NavLink>,
	},
	{
		key: '/logs',
		icon: <UnorderedListOutlined />,
		label: <NavLink to="/logs">Logs</NavLink>,
	},
	{
		key: '/organizations',
		icon: <BankOutlined />,
		label: <NavLink to="/organizations">Organizations</NavLink>,
	},
	{
		key: '/complexes',
		icon: <AppstoreOutlined />,
		label: <NavLink to="/complexes">Living complexes</NavLink>,
	},
	{
		key: '/lots',
		icon: <KeyOutlined />,
		label: <NavLink to="/lots">Lots</NavLink>,
	},
	{
		key: '/users',
		icon: <UserOutlined />,
		label: <NavLink to="/users">Users</NavLink>,
	},
];

const Navbar: React.FC = () => {
	const { pathname } = useLocation();

	return (
		<S.Navbar>
			<Menu selectedKeys={[pathname]} mode="horizontal" items={menuItems} />
		</S.Navbar>
	);
};

export default Navbar;
